import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { AuthService } from '../../../../services/auth/auth.service';
import { LoaderService } from '../../../../services/loader/loader.service';
import { ToastService } from '../../../../services/toast/toast.service';
import { UserService } from '../../../../services/user/user.service';
import Address from '../../../models/user/address';
import User from '../../../models/user/user';
import { validZipCode } from '../../../utils/validators';
import {
  AddressComponent,
  AddressDisable,
  AddressError,
} from '../../address/address.component';

@Component({
  selector: 'app-address-customers',
  standalone: true,
  imports: [AddressComponent, ToastModule],
  templateUrl: './address-customers.component.html',
  styleUrl: './address-customers.component.scss',
})
export class AddressCustomersComponent {
  public address: Address = new Address();
  public addressDisable: AddressDisable = new AddressDisable();
  public addressError: AddressError = new AddressError();
  public user: User = new User();

  constructor(
    private authService: AuthService,
    private toastService: ToastService,
    private userService: UserService,
    private loaderService: LoaderService
  ) {
    this.authService.userData$.subscribe((res: any) => {
      this.user = new User();
      if (res) {
        this.user = new User();
        this.user.fromJson(res);
        this.address = this.user.getAddress(true);
        this.address.id = undefined;
        this.addressDisable.complement = false;
        this.addressDisable.number = false;
      }
    });
  }

  onClickUpdate() {
    const validUser = this.validAddress();
    if (validUser) {
      this.update();
    } else {
      this.toastService.error('É necessário preencher todos os campos!');
    }
  }

  validAddress() {
    let hasError = true;
    this.addressError.errorZipCode = !validZipCode(this.address.zipCode || '');
    this.addressError.errorAddress = !this.address.address;
    this.addressError.errorNumber = !this.address.numberAddress;
    this.addressError.errorComplement = !this.address.complement;
    this.addressError.errorDistrict = !this.address.district;
    this.addressError.errorUF = !this.address.uf;
    this.addressError.errorCity = !this.address.city;

    hasError =
      this.addressError.errorZipCode ||
      this.addressError.errorAddress ||
      this.addressError.errorNumber ||
      this.addressError.errorComplement ||
      this.addressError.errorDistrict ||
      this.addressError.errorUF ||
      this.addressError.errorCity;

    return !hasError;
  }

  async update() {
    try {
      this.loaderService.show();
      await this.userService.update(this.user);
      this.toastService.success('Seus endereço foi alterado com sucesso!');
    } catch (error: any) {
      this.toastService.error(error || 'Erro ao alterar seu endereço!');
    } finally {
      this.loaderService.hide();
    }
  }
}
